"use client";

import { useNetworkStatus } from "@/hooks/useNetworkStatus";

export function NetworkStatusBanner() {
    const isOnline = useNetworkStatus();

    if (isOnline) return null;

    return (
        <div className="fixed top-0 left-0 right-0 z-[9999] bg-yellow-400 text-yellow-900 text-center py-2 px-4 text-sm font-medium shadow-md">
            Sin conexión a internet — Algunas funciones pueden no estar disponibles
        </div>
    );
}
